export default {"src":"/_next/static/media/updated-calendar.87ccc61f.svg","height":320,"width":320,"blurWidth":0,"blurHeight":0};